import React, { Component } from 'react';
import { getBilldetail, pay, getBilldetailGzh, payGzh, complain } from "./services";
import {
    Toast,
} from 'antd-mobile';
import './index.scss';
import wx from 'weixin-js-sdk';
import { GetRequest } from "../../utils/util";

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
            wx: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            ali: u.indexOf('AlipayClient') > -1
        };
    }(),
}
class Billdetail extends Component {
    ref = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            billdetail: {},
            showModal: false,
            btnContent: '--',
            tipContent: '确定',
            pay: false,
            tip: false,
            showModalErr: false,
            errtipContent: "您还未授权，请先去钱包页面授权后，再重新请求代扣",
            sTitle: '',
            isGzh: false
        }
    }
    initData() {
        this.getBilldetailFn()
        return;
        var ua = navigator.userAgent.toLowerCase();
     
        if (browser.versions.ios) {
            let data = JSON.parse(GetRequest().data);
            window.localStorage.setItem('token', data.token);
            this.setState({
                projectId: data.projectId,
                accountId: data.accountId,
                orderId: data.orderId,
                token: data.token,
                userId: data.userId,
                consumeDate: data.consumeDate
            }, () => {
                const { accountId, projectId, orderId, token, userId, consumeDate } = this.state;
                this.getBilldetailFn(accountId, projectId, orderId, token, userId, consumeDate);
            })
            return;
        }
    }
    componentDidMount() {
        document.title = '账单详情';
        window.getParams = this.getParams;
        // this.initData()
    }
    getParams = (orderId,operatePassword, projectId,  userType,telephone, accountId, consumeDate) => {
        // orderId，operatePassword，projectId，userType，telephone，accountId，consumeDate
       
        this.setState({
            orderId,operatePassword, projectId,  userType,telephone, accountId, consumeDate
        }, () => {
            this.getBilldetailFn(orderId,operatePassword, projectId,  userType,telephone, accountId, consumeDate);
        })
    }

    getBilldetailFn = (orderId,operatePassword, projectId,  userType,telephone, accountId, consumeDate) => {
        // "232", "888888", "405", "1", "18575679032", "34", "2024-11-27 11:51:48"
        // let params = {
        //     orderId:"232",
        //     operatePassword:"888888",
        //     projectId:"405",
        //     userType:"1",
        //     telephone:"18575679032",
        //     accountId:"34",
        //     consumeDate:"2024-11-27 11:51:48".replace(/^0+|[^0-9]/g,'').replace(/^0+|[^0-9]/g,''),
        // }
        let params = {
            orderId,
            operatePassword,
            projectId,
            userType,
            telephone,
            accountId,
            consumeDate:consumeDate.replace(/^0+|[^0-9]/g,'').replace(/^0+|[^0-9]/g,''),
        }
        // if (!orderId) {
        //     params.consumeDate = this.state.consumeDate || consumeDate
        // }
        getBilldetail(params).then((res) => {
            if (res.errorCode === 0) {
                let num = (res.data.consumeDate).replace(/[^0-9]/ig, "");
                res.data.orderNumber = num;

                this.setState({
                    billdetail: res.data
                }, () => {
                });

            }
        })
    }
    showTip = () => {
        this.setState({
            pay: false,
            tip: true,
            tipContent: "由于现场网络信号不稳或和设备蓝牙连接断开，导致该笔消费数据未结算。您可以尝试通过手机蓝牙再次连接该设备（<span style='color:#FC5A5A'>不需要点击使用</span>）进行自动结算，或者等待设备在线(连接)后自动结算"
            , btnContent: "我知道了"
        }, () => {
            this.setState({ showModal: true })
        })
    }
    gotoPay = () => {
        const { billdetail, } = this.state;
        const { tradeSettlement, deductType, walletConsumeMoney, } = billdetail;
        if (walletConsumeMoney == 0 && tradeSettlement == 0 && deductType == 6) {
            this.PayFn()
            return;
        }
        this.setState({
            tip: false,
            pay: true,
            tipContent: "请先确保代扣已授权，确保代扣账户有足够金额！",
            btnContent: "重新请求代扣"
        }, () => {
            this.setState({ showModal: true })
        })
    }
    PayFn = () => {
        const { billdetail, projectId, accountId, token, userId } = this.state;
        const { deductType, consumeDate, orderId } = billdetail;
        let params = {
            deductType,
            consumeDate,
            projectId,
            accountId,
            loginCode: token,
            userId
        }
        pay(params).then((res) => {
            if (res.errorCode == 0) {
                const { tradeSettlement, deductType, walletConsumeMoney, } = billdetail;
                if (deductType == 6) {
                    Toast.show({
                        icon: 'success',
                        content: '支付成功',
                        duration: 1100,
                    })
                } else {
                    Toast.show({
                        icon: 'success',
                        content: '已请求',
                        duration: 1100,
                    })
                }
                setTimeout(() => {
                    this.setState({ showModal: false, showModalErr: false })
                    this.getBilldetailFn(accountId, projectId, orderId, token, userId);
                }, 1000)

            } else if (res.errorCode == 221) {
                this.setState({
                    sTitle: false,
                    errtipContent: '您还未授权，请先去钱包页面授权后再重新请求代扣'
                }, () => {
                    this.setState({ showModalErr: true })
                })
            } else {
                this.setState({
                    sTitle: false,
                    errtipContent: res.errorMessage
                }, () => {
                    this.setState({ showModalErr: true })
                })
            }
        })
    }
    renderModal = () => {
        const { showModal, btnContent, tipContent, tip } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModal ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModal ? "board display" : "board"}>
                    <div className="titile"><span>提示</span></div>
                    <div className='content mg30'>
                        <div className="text-box">
                            <span dangerouslySetInnerHTML={{ __html: tipContent }} className={tip ? "t_value_center left" : "t_value_center"}></span>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span className="towBtn bgb" onClick={() => this.submit()}>{btnContent}</span>
                    </div>
                </div>
            </>
        )
    }
    renderModalErr = () => {
        const { showModalErr, errtipContent, sTitle } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModalErr ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModalErr ? "board display" : "board"}>
                    <div className="titile"><span>{sTitle || '提示'}</span></div>
                    <div className='content mg30'>
                        <div className="text-box">
                            <div dangerouslySetInnerHTML={{ __html: errtipContent }} className={sTitle ? "t_value_center left" : "t_value_center"}></div>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span className="towBtn bgb" onClick={() => this.clickHandler()}>我知道了</span>
                    </div>
                </div>
            </>
        )
    }
    clickHandler = () => {
        this.setState({ showModal: false, showModalErr: false })
    }
    submit = () => {

        const { pay, tip } = this.state
        if (pay) {
            this.PayFn()
        }
        if (tip) {
            this.setState({ showModal: false })
        }
    }
    clickHandlerSkip=()=>{
        var ua = navigator.userAgent.toLowerCase();
    
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    console.log('在wx小程序内');
                    let data = GetRequest();
                    wx.miniProgram.navigateTo({
                        url: '../../package_customerService/pages/orderComplainFillIn/orderComplainFillIn?info=' + JSON.stringify(this.state.complainData)
                    })
                    return;
                }
            })
            return;
        }

        if (/Alipay/i.test(navigator.userAgent)) {
            let data = JSON.stringify(this.state.billdetail)
            window.location.href = "alipays://platformapi/startapp?appId=2018090661238647&page=pages/order-appeal/order-appeal&query=appealInfo=" + JSON.stringify(this.state.complainData)
            return;
        }

        if (browser.versions.android) {
            window.android.onOrderComplain();
            return;
        }
        if (browser.versions.ios) {
            window.webkit.messageHandlers.orderAppealClick.postMessage(' ')
            return;
        }
    }
    render() {
        const { billdetail, isGzh, canComplainData } = this.state;
        const { useType, tradeSettlement, runStatus, deviceDescription, consumeMoney, orderNo, consumeSceneType, consumeDate, uploadDate,
            waterUsageShow, waterTemperatureShow, modeInfo, thirdTradeMoney, tradeNo, settlementTime, deductType, monthConsumeMoney, walletConsumeMoney,
            preDeductMoney, consumeMoneyGiven, consumeMoneyReal, canComplain, waterUsageShowSwitch, waterTemperatureShowSwitch, orderNumber,
            reduceMoney, reduceRemark, originalConsumeMoney, comboType, orderOfflineTag
        } = billdetail;
        return (

            <div className='billdetail_container'>
                {this.renderModal()}
                {this.renderModalErr()}
                <div className='billdetail_top'>
                    <div className='status' style={{ color: tradeSettlement == 0 && runStatus == 1 ? '#FC5A5A' : '#5ABDFC' }}>
                        {tradeSettlement == 0 && <span>未支付</span>}
                        {tradeSettlement == 1 && <span>已支付</span>},
                        {runStatus == 0 && <span>未完成</span>}
                        {runStatus == 1 && <span>已完成</span>}
                        <span style={{ visibility: runStatus == 0 ? 'visible' : 'hidden' }} className='doubt' onClick={this.showTip}>使用完还是未完成？</span>

                    </div>
                    <div className='address'>{deviceDescription}</div>
                    {tradeSettlement == 0 && runStatus == 0 && useType == 0 ? '' : <div className='amount'>{consumeMoney}
                        <span className='unit'>元</span>
                    </div>}
                </div>
                <div className='billdetail_bottom'>
                    <div className='item'>
                        <div className='title'>订单金额：</div>
                        <div className='contents'><span>{originalConsumeMoney}元</span></div>
                    </div>
                    {comboType != 0 && <div className='item' >
                        <div className='title'>优惠金额：</div>
                        <div className='contents'>
                            <span>{reduceMoney}元</span><span>({reduceRemark})</span>
                        </div>
                    </div>}
                    <div className='item'>
                        <div className='title'>支付金额：</div>
                        <div className='contents'> {tradeSettlement == 0 && runStatus == 0 && useType == 0 ? '' : <span className='amount'>{consumeMoney}元 </span>}</div>
                    </div>
                    <div className='border'></div>
                    <div className='item'>
                        <div className='title'>订单号：</div>
                        <div className='contents'><span>{orderNumber}</span></div>
                        {orderOfflineTag == 1 ? <div className='offline'>延时结算订单</div> : null}
                    </div>
                    <div className='item'>
                        <div className='title'>消费类型：</div>
                        <div className='contents'>
                            {consumeSceneType == 0 && <span>手机消费</span>}
                            {consumeSceneType == 2 && <span>卡片消费</span>}
                            {consumeSceneType == 3 && <span>密码消费</span>}
                        </div>
                    </div>
                    <div className='item'>
                        <div className='title'>使用时间：</div>
                        <div className='contents'><span>{consumeDate}</span></div>
                    </div>
                    {useType == 1 ? '' : <div className='item'>
                        <div className='title'>完成时间：</div>
                        <div className='contents'><span>{uploadDate}</span></div>
                    </div>}
                    <div className='item' style={{ display: useType == 1 ? 'flex' : 'none' }}>
                        <div className='title'>模式：</div>
                        <div className='contents'>
                            <span>{modeInfo}</span>
                        </div>
                    </div>
                    {/* {tradeSettlement == 0 && runStatus == 0 ? '' : <div className='item' style={{ display: (waterTemperatureShowSwitch == 1 || waterUsageShowSwitch == 1) ? 'flex' : 'none' }}>
                        <div className='title'>用水详情：</div>
                        <div className='contents'>
                            {waterUsageShowSwitch == 1 ? <span style={{ marginRight: '0.24rem' }}>用水量:{waterUsageShow > 0 ? waterUsageShow + "L" : "--"}</span> : ''}
                            {waterTemperatureShowSwitch == 1 ? <span>用水水温:{waterTemperatureShow > 0 ? waterTemperatureShow + "°C" : '--'}</span> : ''}
                        </div>
                    </div>} */}
                    {tradeSettlement == 0 && runStatus == 0 ? '' : <div className='item' style={{ display: (waterTemperatureShow != -1 || waterUsageShow != -1) ? 'flex' : 'none' }}>
                        <div className='title'>用水详情：</div>
                        <div className='contents'>
                            {waterUsageShow != -1 ? <span style={{ marginRight: '0.24rem' }}>用水量:{waterUsageShow != 'null' ? waterUsageShow + "L" : "--"}</span> : ''}
                            {waterTemperatureShow != -1 ? <span>用水水温:{waterTemperatureShow != 'null' ? waterTemperatureShow + "°C" : '--'}</span> : ''}
                        </div>
                    </div>}
                    {preDeductMoney == 0 ? '' : useType == 0 ? <div className='item'>
                        <div className='title'>钱包预扣费：</div>
                        <div className='contents'><span>{preDeductMoney}元{runStatus == 0 ? '（未结算）' : '（已结算）'}</span></div>
                    </div> : ''}
                    {deductType == 10 ? ''
                        : walletConsumeMoney != 0 ? <div className='item'>
                            <div className='title'>钱包支付：</div>
                            <div className='contents'>
                                <span>{walletConsumeMoney}元</span>
                                （<span>{`现金余额支付:${consumeMoneyReal}元`}</span>
                                <span>{`，赠送余额支付:${consumeMoneyGiven}元`}</span>）
                            </div>
                        </div> : ''}
                    {walletConsumeMoney == 0 && tradeSettlement == 0 && deductType == 6 ? <div className='item'>
                        <div className='title'>钱包支付：</div>
                        <div className='contents'>
                            <span>{thirdTradeMoney}元（未支付）</span>
                        </div>
                    </div> : ''}
                    {tradeSettlement == 0 && runStatus == 0 ? '' : deductType == 3 || deductType == 5 ? <><div className='item'>
                        <div className='title'>{deductType == 3 ? '支付宝' : "微信"}代扣：</div>
                        <div className='contents'><span>{thirdTradeMoney}元{tradeSettlement == 0 ? '（未支付）' : '（已支付）'}</span></div>
                    </div>
                        {tradeSettlement == 1 && tradeNo ? <div className='item'>
                            <div className='title'>代扣支付单号：</div>
                            <div className='contents'><span>{tradeNo}</span></div>
                        </div> : ''}
                        {tradeSettlement == 1 && settlementTime ? <div className='item'>
                            <div className='title'>代扣支付时间：</div>
                            <div className='contents'><span>{settlementTime}</span></div>
                        </div> : ''}
                    </> : ''}
                </div>
            </div>
        )
    }
}
export default Billdetail;

